/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ProspectsReportColumn {
  id = 'id',
  isDemo = 'isDemo',
  name = 'name',
  state = 'state',
  createdAt = 'createdAt',
  prospectCoverageStartDate = 'prospectCoverageStartDate',
  estimatedEmployees = 'estimatedEmployees',
  estimatedParticipationRate = 'estimatedParticipationRate',
  zorroPartnerName = 'zorroPartnerName',
  producerName = 'producerName',
  producerAgentName = 'producerAgentName',
  enrollmentTeamNames = 'enrollmentTeamNames',
}
